export default {
  EVENTS_PER_PAGE: 5
};
